import React, { useEffect, useState } from "react";
import TableContainer from "../../Components/TableContainer/TableContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router";
import {
  loader,
  searchDataWithMultipleKeys,
  paginate,
  snackbar,
} from "../../utils";
import {
  deleteChannelCategory,
  deletePlan,
  getAllAppVersion,
  getAllChannelCategory,
  getAllPlans,
} from "../../Components/service/admin";
import { DeleteButton } from "../../Components/Buttons/DeleteButton";
import { AddAppVersion } from "./AddAppVersion";

export default function AppVersionList() {
  const [search, setSearch] = useState("");
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  // console.log(allData);

  const navigate = useNavigate();

  // Fetch all packages
  async function getAllAppVersionFunc() {
    try {
      loader.start();
      let res = await getAllAppVersion();
      setAllData(res?.data?.data?.app || []);
      setFilteredData(res?.data?.data?.app || []);
    } catch (error) {
      console.log(error);
    } finally {
      loader.stop();
    }
  }

  useEffect(() => {
    getAllAppVersionFunc();
  }, []);

  // Handle search
  //   useEffect(() => {
  //     const searchedData = searchDataWithMultipleKeys(
  //       ["plackage_name"],
  //       allData,
  //       search
  //     );
  //     setFilteredData(searchedData);
  //     setPage(0);
  //   }, [search, allData]);

  // Delete handler
  async function deleteChannelCategory(data) {
    try {
      loader.start();
      await deleteChannelCategory(data._id);
      snackbar.success("channel Category deleted successfully");
      setAllData((prevData) =>
        prevData.filter((item) => item._id !== data._id)
      );
      setFilteredData((prevData) =>
        prevData.filter((item) => item._id !== data._id)
      );
    } catch (error) {
      console.log(error);
    } finally {
      loader.stop();
    }
  }

  // Paginate the filtered data
  //   const paginatedData = paginate(filteredData, page, rowsPerPage);

  return (
    <>
      <h2 className="fw-600">App Version</h2>
      <div className="row mt-4">
        {/* <div className="col-lg-5 col-md-6 col-sm-12 col-12">
          <input
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search"
            className="form-control"
          />
        </div> */}
        {/* <div className="col w-100 d-flex justify-content-end">
          <AddAppVersion onSubmit={getAllAppVersionFunc} />
        </div> */}
      </div>
      <div className="mt-4">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Version Code</TableCell>
                <TableCell>Version Name</TableCell>
                <TableCell>Update Date</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {allData?.map((res, index) => ( */}
              <TableRow>
                <TableCell className="pointer text-capitalize">
                  {allData?.versionCode}
                </TableCell>
                <TableCell className="pointer text-capitalize">
                  {allData?.versionName}
                </TableCell>
                <TableCell className="pointer text-capitalize">
                  {allData?.updatedAt?.slice(0, 10)}
                </TableCell>

                <TableCell>
                  <div className="d-flex gap-2">
                    <AddAppVersion
                      formData={allData}
                      mode="edit"
                      onSubmit={getAllAppVersionFunc}
                    />
                    {/* <DeleteButton
                      confirmation
                      display={"Channel Category"}
                      data={allData}
                      onDelete={deleteChannelCategory}
                    /> */}
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          {/* Table Pagination */}
          {/* <TablePagination
            component="div"
            count={filteredData.length} // Total count of filtered data
            page={page} // Current page value
            onPageChange={(event, newPage) => setPage(newPage)} // Handle page change
            rowsPerPage={rowsPerPage} // Number of rows per page
            rowsPerPageOptions={[rowsPerPage]} // Disable changing rows per page
          /> */}
        </TableContainer>
      </div>
    </>
  );
}
